/* eslint-disable max-len */
// ==============================================
// ==================Import======================
// ==============================================

// ==================Style&IMG===================
import './style.scss';

// ==================Hooks react===================
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { globalConfig } from '../../configuration/config';

// ==================Action===================
import { setBtnExport, setFileNoData, setOpenModalExportQuery } from '../../actions/menuButton';
import { setOpenModal } from '../../actions/file';

function MenuButton() {
  // ==================HOOK===================
  const location = useLocation();
  const dispatch = useDispatch();
  const marker = useSelector((state) => state.metadata.data.stationShortData.marker_long_name);
  const fullData = useSelector((state) => state.metadata.data.stationFullData);
  const stringGridSelect = useSelector(
    (state) => state.multipleMetadata.dataMultiple.stringGridSelect,
  );
  const multipleStationsSelected = useSelector(
    (state) => state.multipleMetadata.dataMultiple.multipleStationsSelected,
  );
  const pageFileSelected = useSelector((state) => state.files.pageFileSelected);
  const networkFullData = useSelector(
    (state) => state.network.networkFullData,
  );

  // ===========environnement variables=============
  const server = globalConfig.config.REACT_APP_NODE_URL;
  const API = globalConfig.config.REACT_APP_GLASS_API;

  // ==================handler===================
  function handleOpenModalExportQuery() {
    dispatch(setOpenModalExportQuery(true));
  }

  // function addToHistory() {
  //   const addHistory = `${server}${location.pathname.substring(1)}`;
  //   localStorage.setItem('history', JSON.stringify(addHistory));

  //   let allHistory = JSON.parse(localStorage.getItem('allHistory'));
  //   if (allHistory == null) allHistory = [];
  //   const historySelected = JSON.parse(localStorage.getItem('history'));
  //   if (allHistory.includes(historySelected) === false) {
  //     allHistory.push(addHistory);
  //     localStorage.setItem('allHistory', JSON.stringify(allHistory));
  //     dispatch(setAddToHistory(allHistory));
  //   }
  // }

  // ===============functions==============

  // all download functions to dowload file or scripts to download (with blob)
  function downloadGeodeSymlFile() {
    let adress = '';
    if (location.pathname.includes('metadata/marker=')) {
      adress = `${`${server + API}/webresources/log/geodesyml/${marker}`}`;
    }
    else if (location.pathname.includes('metadata_multiple/marker=') || location.pathname.includes('metadata_multiple/&')) {
      adress = `${`${server + API}/webresources/log/geodesyml/${stringGridSelect}`}`;
    }
    window.open(adress, '_self');
  }

  function downloadSitelogFile() {
    let adress = '';
    if (location.pathname.includes('metadata/marker=')) {
      adress = `${`${server + API}/webresources/log/${marker}`}`;
    }
    else if (location.pathname.includes('metadata_multiple/marker=') || location.pathname.includes('metadata_multiple/&')) {
      adress = `${`${server + API}/webresources/log/${stringGridSelect}`}`;
    }
    window.open(adress, '_self');
  }

  function download() {
    let data;
    let nameData;

    if (location.pathname.includes('metadata/marker=')) {
      data = fullData;
      nameData = `stations-metadata-${fullData[0].marker_long_name}.json`;
    }

    if (location.pathname.includes('metadata_multiple/marker=') || location.pathname.includes('metadata_multiple/&')) {
      data = multipleStationsSelected;
      nameData = `stations-metadata-${stringGridSelect}.json`;
    }

    if (location.pathname.includes('file/')) {
      data = pageFileSelected;
      nameData = 'files-metadata.json';
    }

    if (location.pathname.includes('network/name=')) {
      data = networkFullData;
      nameData = 'networks-metadata.json';
    }

    const blob = new Blob([JSON.stringify(data)], {
      type: 'text/json',
    });
    if (data.length > 0) {
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveBlob(blob, nameData);
      }
      else {
        const elem = window.document.createElement('a');
        elem.href = window.URL.createObjectURL(blob);
        elem.download = nameData;
        document.body.appendChild(elem);
        elem.click();
        document.body.removeChild(elem);
      }
    }
    else {
      dispatch(setFileNoData(true));
    }
  }

  function downloadWget() {
    let scriptText = '';
    let link = '';
    for (let i = 0; i < pageFileSelected.length; i += 1) {
      if (pageFileSelected[i].data_center.data_center_structure.directory_naming !== '') {
        link = `${pageFileSelected[i].data_center.protocol}://${pageFileSelected[i].data_center.hostname}/${pageFileSelected[i].data_center.data_center_structure.directory_naming}/${pageFileSelected[i].relative_path}/${pageFileSelected[i].name}`;
      }
      else {
        link = `${pageFileSelected[i].data_center.protocol}://${pageFileSelected[i].data_center.hostname}/${pageFileSelected[i].relative_path}/${pageFileSelected[i].name}`;
      }
      scriptText = `${scriptText}wget ${link}\n`;
    }
    if (scriptText.length > 0) {
      const blob = new Blob([scriptText], { type: 'text/plain' });
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveBlob(blob, 'eposwget.sh');
      }
      else {
        const elem = window.document.createElement('a');
        elem.href = window.URL.createObjectURL(blob);
        elem.download = 'eposwget.sh';
        document.body.appendChild(elem);
        elem.click();
        document.body.removeChild(elem);
      }
    }
    else {
      dispatch(setFileNoData(true));
    }
  }
  function downloadTxt() {
    let scriptText = '';
    let link = '';
    for (let i = 0; i < pageFileSelected.length; i += 1) {
      if (pageFileSelected[i].data_center.data_center_structure.directory_naming !== '') {
        link = `${pageFileSelected[i].data_center.protocol}://${pageFileSelected[i].data_center.hostname}/${pageFileSelected[i].data_center.data_center_structure.directory_naming}/${pageFileSelected[i].relative_path}/${pageFileSelected[i].name}`;
      }
      else {
        link = `${pageFileSelected[i].data_center.protocol}://${pageFileSelected[i].data_center.hostname}/${pageFileSelected[i].relative_path}/${pageFileSelected[i].name}`;
      }
      scriptText = `${scriptText}${link}\r\n`;
    }
    if (scriptText.length > 0) {
      const blob = new Blob([scriptText], { type: 'text/plain' });
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveBlob(blob, 'eposfilelist.txt');
      }
      else {
        const elem = window.document.createElement('a');
        elem.href = window.URL.createObjectURL(blob);
        elem.download = 'eposfilelist.txt';
        document.body.appendChild(elem);
        elem.click();
        document.body.removeChild(elem);
      }
    }
    else {
      dispatch(setFileNoData(true));
    }
  }

  // ==========handler============

  // Handler to dispatch action to store and reducer

  function handleOpenModal() {
    dispatch(setOpenModal(true));
  }

  function onBtnExport() {
    dispatch(setBtnExport(true));
  }

  return (
    <div id="dropdownconteneur2" className="btn-group">
      {/* <div>
        <button
          type="button"
          className="btn btn-add"
          title="This button allows to keep in cache history of yours requests"
          onClick={addToHistory}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-clipboard-plus-fill" viewBox="0 0 16 16">
            <path d="M6.5 0A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3Zm3 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3Z" />
            <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1A2.5 2.5 0 0 1 9.5 5h-3A2.5 2.5 0 0 1 4 2.5v-1Zm4.5 6V9H10a.5.5 0 0 1 0 1H8.5v1.5a.5.5 0 0 1-1 0V10H6a.5.5 0 0 1 0-1h1.5V7.5a.5.5 0 0 1 1 0Z" />
          </svg>
          Add to history
        </button>
      </div> */}
      <div className="dropdown">
        <button type="button" className="btn btn-download dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false" id="download" title="This button allows to download the content of data in different format">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-download" viewBox="0 0 16 16">
            <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
            <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
          </svg>
          Download
        </button>
        <ul className="dropdown-menu">
          {(location.pathname.includes('metadata_multiple/marker=') || location.pathname.includes('metadata/marker=') || location.pathname.includes('metadata_multiple/&')) && (
            <>
              <li><a onClick={downloadGeodeSymlFile} className="dropdown-item">GeodesyML</a></li>
              <li><a onClick={download} className="dropdown-item">Json</a></li>
              <li><a onClick={downloadSitelogFile} className="dropdown-item">IGS Site Log</a></li>
            </>
          )}
          {(location.pathname.includes('file/')) && (
            <>
              <li><a onClick={download} className="dropdown-item">Json</a></li>
              <li><a onClick={downloadWget} className="dropdown-item">Wget Unix Script</a></li>
              <li><a onClick={downloadTxt} className="dropdown-item">File list</a></li>
              <li><a onClick={handleOpenModal} className="dropdown-item">Download selected</a></li>
            </>
          )}
          {(location.pathname.includes('network/name=')) && (
            <li><a onClick={download} className="dropdown-item">Json</a></li>
          )}
        </ul>
      </div>
      <div className="dropdown">
        <button type="button" className="btn btn-export dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false" id="exportquery" title="This button allows to get the query for command line">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-rocket-takeoff-fill" viewBox="0 0 16 16">
            <path d="M12.17 9.53c2.307-2.592 3.278-4.684 3.641-6.218.21-.887.214-1.58.16-2.065a3.578 3.578 0 0 0-.108-.563 2.22 2.22 0 0 0-.078-.23V.453c-.073-.164-.168-.234-.352-.295a2.35 2.35 0 0 0-.16-.045 3.797 3.797 0 0 0-.57-.093c-.49-.044-1.19-.03-2.08.188-1.536.374-3.618 1.343-6.161 3.604l-2.4.238h-.006a2.552 2.552 0 0 0-1.524.734L.15 7.17a.512.512 0 0 0 .433.868l1.896-.271c.28-.04.592.013.955.132.232.076.437.16.655.248l.203.083c.196.816.66 1.58 1.275 2.195.613.614 1.376 1.08 2.191 1.277l.082.202c.089.218.173.424.249.657.118.363.172.676.132.956l-.271 1.9a.512.512 0 0 0 .867.433l2.382-2.386c.41-.41.668-.949.732-1.526l.24-2.408Zm.11-3.699c-.797.8-1.93.961-2.528.362-.598-.6-.436-1.733.361-2.532.798-.799 1.93-.96 2.528-.361.599.599.437 1.732-.36 2.531Z" />
            <path d="M5.205 10.787a7.632 7.632 0 0 0 1.804 1.352c-1.118 1.007-4.929 2.028-5.054 1.903-.126-.127.737-4.189 1.839-5.18.346.69.837 1.35 1.411 1.925Z" />
          </svg>
          Export query
        </button>
        <ul className="dropdown-menu">
          <li><a className="dropdown-item" onClick={handleOpenModalExportQuery}>Json</a></li>
        </ul>
      </div>
      {(window.location.href.includes('metadata/marker=') === false) && (
        <div className="exportButton--container">
          <button type="button" onClick={onBtnExport} className="button--exportCSV">Export CSV file</button>
        </div>
      )}
    </div>
  );
}

export default MenuButton;
